import React, { useEffect, useState } from "react";
import { Box, Card, CardContent } from "@mui/material";
import { Button, DateField, FunctionField, Labeled, SimpleShowLayout, TopToolbar, useGetOne, useNotify, useRedirect } from "react-admin";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useParams } from "react-router-dom";
import { DownloadFile, getNameAndCompanyNamewithAddress, getResource, invoiceChoices } from "../common";
import { TrashButton } from "../components";
import NoteAddIcon from '@mui/icons-material/NoteAdd';

const InvoiceHistoryShow = () => {
  const [record, setRecord] = useState(null);
  const [cleanHistory,setCleanHistory] = useState([]);
  const [inspectHistory,setInspectHistory] = useState([]);
  const [constructHistory,setConstructHistory] = useState([]);
  const { id } = useParams(); 
  const [customers,setCustomers]=useState([]);
  const redirect = useRedirect();
  const [files,setFiles] = useState(null);
  const notify = useNotify();
  
  const { data, isLoading } = useGetOne("invoiceHistory", { id });
  useEffect(() => {
    if(!isLoading && data){
      setRecord(data);
    }
  },[data,isLoading]);

  useEffect(() => {
    const getCustomers = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/customers/all`, {
          method: "GET",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error("Failed to fetch user info");
        }
        const { data } = await response.json();
        setCustomers(data);
      } catch (error) {
        console.error("ユーザー情報の取得に失敗しました:", error);
      } finally {
        // setLoading(false);
      }
    };
    getCustomers();
    getHistory("cleaningHistory");
    getHistory("inspectHistory");
    getHistory("constructHistory");
  }, []);

  const getHistory = async (tableName) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/invoiceHistory/history/${tableName}`, {
        method: "GET",
        headers: new Headers({ "Content-Type": "application/json" }),
        mode: "cors",
        credentials: "include",
      });
      if (!response.ok) {
        throw new Error("Failed to fetch user info");
      }
      const { data } = await response.json();
      if(data){
        console.log(data);
        if(tableName==="cleaningHistory"){
          setCleanHistory(data);  
        }
        else if(tableName==="inspectHistory"){
          setInspectHistory(data);
        }
        else if(tableName==="constructHistory"){
          setConstructHistory(data);
        }
      }
    } catch (error) {
      console.error("ユーザー情報の取得に失敗しました:", error);
    }
  };

  const CustomTopToolbar = () => (
    <Box sx={{ padding: 0, margin: 0 }}>
        <TopToolbar>
            <Button
                label="請求書を作成"
                onClick={() => redirect(`/invoice-form/invoiceHistory/${id}`)}
                startIcon={<NoteAddIcon />}
            />
            <Button
                label="請求情報編集"
                onClick={() => redirect(`/invoiceHistory/${id}`)}
                startIcon={<EditIcon />}
            />
        </TopToolbar>
    </Box>
  );

  const labelStyle = (text) => (
    <div style={{ backgroundColor: "#eee", color: "#666", paddingLeft: "5px" }}>
      {text}
    </div>
  );

  useEffect(()=>{
    if(record){
      const fetchFiles = async () => {
        try {
          const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents/invoice/${record.invoiceId}`,{
            method: "GET",
            headers: new Headers({ "Content-Type": "application/json" }),
            mode: "cors",
            credentials: "include",
          });
          const data = await response.json();
          if (data.files) {
            setFiles(data.files);
          }
        } catch (error) {
          console.error("ファイル一覧の取得に失敗しました:", error);
          notify("ファイル一覧の取得に失敗しました",{type:"error"});
        }
      };
      fetchFiles();
    }
  },[record]);


  const handleDelete = (filePath) => {
    const deleteFile = async (filePath) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_DIR}/documents`,{
          method: "DELETE",
          headers: new Headers({ "Content-Type": "application/json" }),
          mode: "cors",
          credentials: "include",
          body: JSON.stringify({filePath}),
        });
        const data = await response.json();
        if (data.isError) {
          notify(data.message || "エラーが発生しました",{type:"error"});
        }
        else{
          notify("削除されました",{type:"sccuess"});
          window.location.reload();
        }
      } catch (error) {
        notify("エラーが発生しました",{type:"error"});
      }
    };
    deleteFile(filePath);
  };


  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent>
          <SimpleShowLayout record={record}>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              {/* <Labeled label={labelStyle("請求No")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField source="number" label={labelStyle("請求No")} style={{ paddingLeft: "5px" }} render={(record) => {
                  return String(record.number).padStart(5, "0");
                }}/>
              </Labeled> */}
              <Labeled label={labelStyle("請求対象区分")} style={{ flex: 1 , marginRight: "10px"}}>
                <FunctionField
                  label="請求対象区分"
                  render={record => {
                    const choice = invoiceChoices.find(choice => choice.id === record.invoiceCategory);
                    return choice ? choice.name : ""; 
                  }}
                />
              </Labeled>
              <Labeled label={labelStyle("請求対象区分")} style={{ flex: 1 }}>
              <FunctionField
                  label="請求対象"
                  render={record => {
                    if(record.invoiceCategory === 1){
                      const history = (cleanHistory && cleanHistory.length > 0) ? cleanHistory.find(history => history.invoceId === record.invoceId) : null;
                      return history ? <Link to={`/cleanHistory/show/${history.cleaningId}`} >清掃履歴</Link> : ""; 
                    }
                    else if(record.invoiceCategory === 2){
                      const history = (inspectHistory && inspectHistory.length > 0) ? inspectHistory.find(history => history.invoceId === record.invoceId) : null;
                      return history ? <Link to={`/inspectHistory/show/${history.inspectId}`} >点検履歴</Link> : ""; 
                    }
                    else if(record.invoiceCategory === 3){
                      const history = (constructHistory && constructHistory.length > 0) ? constructHistory.find(history => history.invoceId === record.invoceId) : null;
                      return history ? <Link to={`/constructHistory/show/${history.constructId}`} >修理履歴</Link> : ""; 
                    }
        
                  }}
                />
              </Labeled>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Labeled label={labelStyle("請求日")} style={{ flex: 1, marginRight: "10px" }}>
                <DateField source="invoiceDate" label={labelStyle("請求日")} style={{ paddingLeft: "5px" }}/>
              </Labeled>
              <Labeled label={labelStyle("請求金額(税抜き)")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField source="invoiceAmount" label={labelStyle("請求金額(税抜き)")} style={{ paddingLeft: "5px" }} render={record => {return record.invoiceAmount ? `${record.invoiceAmount.toLocaleString()}円` : ""}} />
              </Labeled>
              <Labeled label={labelStyle("支払い方法")} style={{ flex: 1}}>
                <FunctionField source="payMethod" label={labelStyle("支払い方法")} style={{ paddingLeft: "5px" }} render={record => {return record.payMethod}} />
              </Labeled>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <Labeled label={labelStyle("再発行日")} style={{ flex: 1, marginRight: "10px" }}>
                <DateField source="reissueDate" label={labelStyle("再発行日")} style={{ paddingLeft: "5px" }}/>
              </Labeled>
              <Labeled label={labelStyle("領収")} style={{ flex: 1, marginRight: "10px" }}>
                <FunctionField
                  source="isPay"
                  label={labelStyle("領収")} style={{ paddingLeft: "5px" }}
                  render={(record) => {
                    return record.isPay ? "領収済み": "";
                  }}
                />
              </Labeled>
              <Labeled label={labelStyle("領収日")} style={{ flex: 1 }}>
                <DateField source="receiptDate" label={labelStyle("領収日")} style={{ paddingLeft: "5px" }}/>
              </Labeled>
            </div>
            <FunctionField
              source="customerId"
              label={labelStyle("顧客名")} 
              style={{ paddingLeft: "5px" }}
              render={(record) => {
                const customer = customers.find(req => req.id === record.customerId);
                return customer ? <Link to={`/${getResource(customer)}/show/${record.customerId}`}>{getNameAndCompanyNamewithAddress(customer)}</Link> : "";
              }}
            />
            <FunctionField
              source="documentURL"
              label={labelStyle("請求書ファイル")}
              render={(record) => (
                <div style={{ paddingLeft: "5px",margin:"0" }}>
                  {files && files.length > 0 ? (
                    <>
                      {files.map((file, index) => (
                        <div key={index}>
                          <Link onClick={() => DownloadFile(file.url)} >{file.name}</Link>
                          <TrashButton onDelete={() => handleDelete(file.url)} />
                        </div>
                      ))}
                    </>
                  ) : null}
                </div>
              )}
            />
          </SimpleShowLayout>
        </CardContent>
      </Card>
    </>

  );
};

export default InvoiceHistoryShow;

